export function generateAlphaNumeric() {
  const length = 8;
  const chars = 'abcdefghjkmnpqrstuvwxyz23456789ABCDEFGHJKMNPQRSTUVWXYZ';
  const charsLength = chars.length;
  let referenceNumber = '';

  for (let i = 0; i < length; i++) {
    referenceNumber += chars.charAt(Math.floor(Math.random() * charsLength));
  }
  return `HARP${referenceNumber}`;
}
